import { render, staticRenderFns } from "./UserRatio.vue?vue&type=template&id=e4c5bdf2&"
import script from "./UserRatio.vue?vue&type=script&lang=js&"
export * from "./UserRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports